

import { h } from 'preact';

export default function (props) {
    var styles = props.styles;
    var rest = Object.assign({}, props);
    delete rest.styles;

    return h('svg', Object.assign({"width":"22","height":"22","viewBox":"0 0 22 22","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, rest), ["\n", h('path', {"d":"M2 2L20 20M20 2L2 20L20 2Z","stroke":"current","stroke-width":"2.04","stroke-linecap":"round","stroke-linejoin":"round"}, []), "\n"]);
};

        